import * as Yup from 'yup';

export const geofenceCoordinateSchema = Yup.object({
    latitude: Yup.number(),
    longitude: Yup.number(),
}).strict();

export const updateGeofenceSchema = Yup.object().shape({
    id: Yup.string().required(),
    description: Yup.string().min(3).max(200).required(),
    coordinates: Yup.array(geofenceCoordinateSchema).required(),
    phoneNumber: Yup.string().required(),
});

export const bulkGeofencesUpdateSchema = Yup.array(Yup.object().shape({
    id: Yup.string(),
    coordinates: Yup.array(geofenceCoordinateSchema).required(),
}));

export const createGeofenceSchema = Yup.object().shape({
    description: Yup.string().required('Please, fill the geofence name'),
    coordinates: Yup.array(geofenceCoordinateSchema).required(),
    phoneNumber: Yup.string().required('Select the phone numbers to notify')
});

export const createGeoPhoneSchema = Yup.object().shape({
    phone: Yup.string().required('Please, fill the phone number'),
    label: Yup.string().required('Please, fill the phone label'),
    type: Yup.string().required('Please, select the phone type'),
});

export const updateGeoPhoneSchema = Yup.object().shape({
    id: Yup.string().required(),   
    phone: Yup.string().required('Please, fill the phone number'),
    label: Yup.string().required('Please, fill the phone label'),
    type: Yup.string().required('Please, select the phone type'),
}).strict();